import React, { Component, Fragment } from "react";
import { languageService } from "../../../Language/language.service";
import { ButtonActionsTable, StyledButtonActionsTable } from "../../Common/Buttons";
import ThisTable from "../../Common/ThisTable";
import UISectionHeader from "../../Common/UISectionHeader";
import CustomForm from "../../../libraries/form";
import _ from "lodash";
import { hosReportOffDutyFormSchema } from "./schemas/hosReportOffDutyFormSchema";
import { ToastService } from "../../../utils/toastify";
import { CRUDFunction } from "../../../reduxCURD/container";
import "./style.css";
import { FixedAppLookupsContext } from "../../FixedAppLookupsProvider";
import { arrayToSelectOptions } from "../../../utils/arrayToSelectOptions";
import { updateShortSchema } from "../../../libraries/form/schemaInterpreter";
import SpinnerLoader from "../../Common/SpinnerLoader";
import moment from "moment";
import { dataFormatters } from "../../../utils/dataFormatters";
import HosValidators from "../Helper/HosValidators";
import { userListRequest } from "../../../reduxRelated/actions/userActions";
import { isJSON } from "../../../utils/isJson";
import UserSelection from "./UserSelection";
import { dateSort } from "../../../utils/sortingMethods";

class ReportOffDuty extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openAddEditOffDutyForm: false,
      addEditOffDutyData: {},
      addEditOffDutyFormSchema: null,
      addEditOffDutyFormState: null,
      selectedOffDutyIndex: -1,
      offDuties: [],
      showloader: false,
      selectedUser: null,
      showUserOptions: false,
    };

    this.closeDialog = this.closeDialog.bind(this);
    this.openAddOffDutyForm = this.openAddOffDutyForm.bind(this);
    this.compileReportOffDutyFormSchema = this.compileReportOffDutyFormSchema.bind(this);
    this.setShowLoader = this.setShowLoader.bind(this);
    this.onSelectedUserChange = this.onSelectedUserChange.bind(this);
  }

  setShowLoader(status) {
    this.setState({ showloader: status });
  }
  onSelectedUserChange(email) {
    this.setState({
      selectedUser: email,
    });
    this.stateChangeReducer("get-off-duties", email);
  }
  componentDidMount() {
    let loggedUser = this.loggedInUser();
    if (loggedUser && loggedUser.group_id === "supervisor") {
      this.props.userListRequest();
      this.setState({ showUserOptions: true, selectedUser: loggedUser.email });
      this.stateChangeReducer("get-off-duties", loggedUser.email);
    } else {
      this.stateChangeReducer("get-off-duties");
    }
  }
  loggedInUser() {
    const loggedInUser = localStorage.getItem("loggedInUser");
    if (loggedInUser) return isJSON(loggedInUser);
  }
  componentWillUnmount() {
    const { timezone } = this.props;
    moment.tz.setDefault(timezone);
    this.stateChangeReducer("get-off-duties");
  }

  componentDidUpdate(prevProps) {
    const { actionType, OffDuty, OffDutys } = this.props;
    const { selectedUser } = this.state;
    if (actionType !== prevProps.actionType) {
      if (actionType === "OFFDUTYS_READ_REQUEST" || actionType === "OFFDUTY_CREATE_REQUEST" || actionType === "OFFDUTY_DELETE_REQUEST") {
        this.setShowLoader(true);
      } else if (actionType === "OFFDUTYS_READ_SUCCESS") {
        this.closeDialog();
        this.setShowLoader(false);
        this.stateChangeReducer("off-duties-received", OffDutys);
      } else if (actionType === "OFFDUTY_CREATE_SUCCESS" || actionType === "OFFDUTY_DELETE_SUCCESS") {
        if (OffDuty && OffDuty["error"]) {
          const { error } = OffDuty;
          ToastService.Error("Error:", error); // An informative error message received from the server
        } else {
          // success
          this.closeDialog();
          this.stateChangeReducer("get-off-duties", selectedUser);
        }
        this.setShowLoader(false);
      } else if (
        actionType === "OFFDUTYS_READ_FAILURE" ||
        actionType === "OFFDUTY_CREATE_FAILURE" ||
        actionType === "OFFDUTY_DELETE_FAILURE"
      ) {
        this.setShowLoader(false);
        this.closeDialog();
      }
    }
  }
  closeDialog() {
    this.setState({
      openAddEditOffDutyForm: false,
      addEditOffDutyFormSchema: null,
      addEditOffDutyData: {},
      addEditOffDutyFormState: null,
      selectedOffDutyIndex: -1,
    });
  }
  getSelectedUser() {
    const { userList } = this.props;
    let selectedUser = userList.find((u) => u.email === this.state.selectedUser);
    if (selectedUser) {
      return selectedUser;
    }
    return null;
  }
  compileReportOffDutyFormSchema() {
    const { getActivityTypeSelectOptionsBasedOnServiceType } = this.context;
    const { timezone, effectiveDate } = this.props;
    let timezoneValue = timezone;
    let effectiveDateValue = effectiveDate;
    let selectedUser = this.getSelectedUser();
    if (selectedUser) {
      timezoneValue = selectedUser.HosInfo.timezone;
      effectiveDateValue = selectedUser.HosInfo.startDate;
    }
    // todo: allow add/delete minDate only after last submitted hos record
    moment.tz.setDefault(timezoneValue);
    let formSchema = updateShortSchema(_.cloneDeep(hosReportOffDutyFormSchema), {
      activityTypeCode: {
        selectOptions: getActivityTypeSelectOptionsBasedOnServiceType("Off Duty"),
      },
      startDate: {
        minDate: moment.tz(effectiveDateValue, timezoneValue).startOf("day"),
      },
      endDate: {
        minDate: moment.tz(effectiveDateValue, timezoneValue).startOf("day"),
      },
    });
    return formSchema;
  }

  openAddOffDutyForm() {
    this.setState({
      openAddEditOffDutyForm: true,
      addEditOffDutyFormSchema: this.compileReportOffDutyFormSchema(),
      addEditOffDutyData: {},
      addEditOffDutyFormState: "create",
    });
  }

  stateChangeReducer(action, data) {
    const { getActivityTypeOpt2BasedOnCode } = this.context;
    const { createOffDuty, getOffDutys, deleteOffDuty } = this.props;
    const { offDuties, selectedOffDutyIndex, selectedUser } = this.state;
    const { timezone } = this.props;
    switch (action) {
      case "add-off-duty":
        {
          let { fields } = data;
          if (HosValidators.validateHosRecordEndDateInPast(fields, true)) {
            let selectedUser = this.getSelectedUser();
            let user = {};
            if (selectedUser) {
              user.timezone = selectedUser.HosInfo.timezone;
              user.userEmail = selectedUser.email;
            }
            createOffDuty &&
              createOffDuty({
                ...fields,
                timezone: timezone,
                activityType: getActivityTypeOpt2BasedOnCode(fields.activityTypeCode),
                endDate: moment(fields.endDate).add(1, "day"),
                ...user,
              });
          }
        }
        break;
      case "delete-off-duty":
        {
          const index = data;

          if (index < offDuties.length) {
            let selectedRow = { ...offDuties[index] };
            selectedRow.endDate = moment.tz(selectedRow.endDate, selectedRow.timezone).subtract(1, "day");
            this.setState({
              selectedOffDutyIndex: index,
              openAddEditOffDutyForm: true,
              addEditOffDutyFormSchema: this.compileReportOffDutyFormSchema(),
              addEditOffDutyData: selectedRow,
              addEditOffDutyFormState: "delete",
            });
          }
        }
        break;
      case "confirm-delete-off-duty":
        {
          offDuties[selectedOffDutyIndex] && deleteOffDuty && deleteOffDuty(offDuties[selectedOffDutyIndex]);
        }
        break;
      case "get-off-duties":
        getOffDutys && getOffDutys(data ? "?email=" + data : "");
        break;
      case "off-duties-received":
        if (Array.isArray(data)) {
          this.setState({
            offDuties: data,
          });
        }
        break;
    }
  }

  render() {
    const { openAddEditOffDutyForm, addEditOffDutyData, addEditOffDutyFormSchema, addEditOffDutyFormState } = this.state;
    const { offDuties } = this.state;
    const { timezone } = this.props;
    return (
      <div>
        <SpinnerLoader spinnerLoading={this.state.showloader} />

        <UISectionHeader
          title={languageService("Add Off Days")}
          addPermission={true}
          addButtonTitle={languageService("Add Off Duty")}
          addCallback={this.openAddOffDutyForm}
        />
        {this.state.showUserOptions && (
          <UserSelection users={this.props.userList} selectedUser={this.state.selectedUser} changeHandler={this.onSelectedUserChange} />
        )}
        <ThisTable
          tableColumns={[
            {
              Header: languageService("Status"),
              accessor: "activityType.value",
              id: "activityType",
              minWidth: 100,
            },
            {
              Header: languageService("Time zone"),
              accessor: "timezone",
              id: "timezone",
              minWidth: 150,
            },
            {
              Header: languageService("Start Date"),
              accessor: "startDate",
              id: "startDate",
              Cell: (d) => dataFormatters.dateFormatterWithTimezone(d.value, d.original.timezone),
              minWidth: 100,
              sortMethod: dateSort,
            },
            {
              Header: languageService("End Date"),
              accessor: "endDate",
              id: "endDate",
              Cell: (d) =>
                dataFormatters.dateFormatterWithTimezone(moment.tz(d.value, d.original.timezone).subtract(1, "day"), d.original.timezone),
              minWidth: 100,
              sortMethod: dateSort,
            },
            {
              Header: languageService("Duration (Days)"),
              accessor: (d) => {
                let startDate = moment.tz(d.startDate, d.timezone);
                let endDate = moment.tz(d.endDate, d.timezone);
                return endDate.diff(startDate, "days");
              },
              id: "duration",
              minWidth: 80,
            },
            {
              Header: languageService("Entered At"),
              accessor: "createdAt",
              id: "enteredAt",
              Cell: (d) => dataFormatters.dateTimeFormatterWithTimezone(d.value, d.original.timezone, true),
              minWidth: 150,
              sortMethod: dateSort,
            },
            {
              Header: languageService("Actions"),
              id: "actions",
              Cell: (d) => {
                const index = d.row._index;
                // TODO: Check for permission
                //   /**permissionCheck("MAINTENANCE", "view") */ true &&
                return (
                  <div>
                    <StyledButtonActionsTable
                      title={languageService("Delete")}
                      onClick={() => this.stateChangeReducer("delete-off-duty", index)}
                    />
                  </div>
                );
              },
              minWidth: 100,
            },
          ]}
          tableData={offDuties}
          pagination={true}
          forDashboard={false}
          height={"auto"}
          onClickSelect
        />
        {openAddEditOffDutyForm && (
          <CustomForm
            mode="dialog"
            currState={addEditOffDutyFormState}
            fieldsData={addEditOffDutyData}
            formSchema={addEditOffDutyFormSchema}
            closeDialog={this.closeDialog}
            parentRef={{
              addOffDuty: (submission) => this.stateChangeReducer("add-off-duty", submission),
              confirmDeleteOffDuty: (submission) => this.stateChangeReducer("confirm-delete-off-duty", submission),
            }}
          />
        )}
      </div>
    );
  }
}

let variableList = {
  userReducer: {
    userList: [],
    userListByGroup: [],
  },
};
let reducers = ["userReducer"];

let actionOptions = {
  read: true,
  create: true,
  update: true,
  delete: true,
  others: { userListRequest },
};

ReportOffDuty.contextType = FixedAppLookupsContext;

const ReportOffDutyContainer = CRUDFunction(ReportOffDuty, "OffDuty", actionOptions, variableList, reducers, "hoursofservice/offDuty");

export default ReportOffDutyContainer;



// WEBPACK FOOTER //
// ./src/components/HoursOfService/ReportOffDuty/index.jsx